/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Start_BodyInputs */

const en_fw_guide_start_body = /** @type {(inputs: Fw_Guide_Start_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you want the story as it unfolds week to week, start with episode one of the Firefly Wedding anime; it opens at the very beginning of the manga. If you cannot wait, the Firefly Wedding manga is complete in Japanese, and the English editions from VIZ Media (print) and Comikey (digital) are steadily catching up.`)
};

const zh_fw_guide_start_body = /** @type {(inputs: Fw_Guide_Start_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想每周跟着剧情走，就从萤火之嫁动画第一话看起，它从漫画的开篇讲起。如果等不及，萤火之嫁漫画日文版已经完结，英文版也由 VIZ Media（实体）与 Comikey（电子）持续推出中。`)
};

/**
* | output |
* | --- |
* | "If you want the story as it unfolds week to week, start with episode one of the Firefly Wedding anime; it opens at the very beginning of the manga. If you ca..." |
*
* @param {Fw_Guide_Start_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_start_body = /** @type {((inputs?: Fw_Guide_Start_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Start_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_start_body(inputs)
	return zh_fw_guide_start_body(inputs)
});
export { fw_guide_start_body as "fw.guide.start.body" }